import { useEffect, useRef, useCallback } from "react";

interface UseInfiniteScrollOptions {
  rootMargin?: string;
  threshold?: number;
  disabled?: boolean;
}

export function useInfiniteScroll(
  callback: () => void,
  options: UseInfiniteScrollOptions = {},
) {
  const { rootMargin = "200px", threshold = 0.1, disabled = false } = options;

  const targetRef = useRef<HTMLDivElement>(null);

  const handleIntersection = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const [entry] = entries;
      if (entry.isIntersecting && !disabled) {
        callback();
      }
    },
    [callback, disabled],
  );

  useEffect(() => {
    const target = targetRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin,
      threshold,
    });

    observer.observe(target);

    return () => observer.disconnect();
  }, [handleIntersection, rootMargin, threshold]);

  return targetRef;
}
